module.exports = __webpack_public_path__ + "img/ooca-logo-color.0eff0992.svg";